import { IUser } from 'core-components/sitebuilder/models/IUser'
import MeasureController from 'core/analytics/MeasureController'

export const measureRequest = async <T>(
  name: string,
  user: IUser,
  request: () => Promise<T>
): Promise<T> => {
  const settings = { startInitializationMeasure: false, user, sendLongMeasure: true }
  const metrics = new MeasureController(name, settings)
  metrics.start('renderData')
  try {
    return await request()
  } finally {
    metrics.stop('renderData')
  }
}
